import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { BrandingResponse, OnboardingSkillResponse } from './Types';

export class AIRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/api/v1';
  }

  public getThreadFiles = async (threadId: string) => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/threads/${threadId}/files`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);

    return data;
  };

  public getFiles = async () => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/files`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);

    return data;
  };

  /**
   * Identidade visual capturada do site da frota do bearer token. Responde sempre 200 — quem
   * discrimina o resultado é `status`, não o código HTTP.
   */
  public getBranding = async (): Promise<BrandingResponse> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/branding`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return data as BrandingResponse;
  };

  /** Skills de onboarding geradas para a frota do bearer token. Também responde sempre 200. */
  public getOnboardingSkill = async (): Promise<OnboardingSkillResponse> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/onboarding/skill`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return data as OnboardingSkillResponse;
  };
}

export default AIRequester;
